// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".87f9ff9e1a205bf11f0a53bd172abf5d.js";
};